<template>
  <div id="userOrder">
    <div class="EmployeesAccountTitle">
      お気に入り店舗
    </div>
    <section>
      <div class="shopHeader">
        <div class="shopHeaderLeft">
          <div class="label">タグ:</div>
          <div class="tagLists">
            <div v-for="(item, index) in tagLists" :key="index"
              :class="form.tag_ids.lastIndexOf(item.id) !== -1 ? 'active' : ''" class="tagContainer"
              @click="updateTagIndex(item)">
              <span>{{ item.tag_name }}</span>
              <!--              <el-input v-else v-model="item.tag_name" size="mini" style="width: 100px"-->
              <!--                        @blur.stop="updateTagName(item)"/>-->
              <img src="@/assets/user/commodity/redEditIcon.png" style="margin-left: 8px"
                @click.stop="getEditTagInfo(item)" />
              <div class="deleteTagContainer" @click.stop="deleteIcon(item)">x</div>
            </div>
          </div>
        </div>
        <div class="shopHeaderRight">
          <div class="keywords flexAndCenter">
            <div class="fontSize14 color222">店舗名：</div>
            <el-input v-model="form.keywords" style="width: 220px" placeholder="店舗名をご記入ください" size="mini" />
          </div>
          <div class="btnList flexAndCenter">
            <div @click="getShopsList">検索</div>
            <div @click="form.keywords = ''; getShopsList()">リセット</div>
          </div>
        </div>
      </div>
      <div class="shops" v-if="shopData.length != 0" v-loading="loading">
        <div class="shopsOpt" v-for="(shopDataitem, shopDataindex) in shopData" :key="shopDataindex">
          <div class="optLeft">
            <div style="margin-bottom: 20px;">
              <h1 :title="shopDataitem.shop_name" class="goodsTitleBox">
                {{ shopDataitem.shop_name }}
              </h1>
            </div>
            <el-input v-model="shopDataitem.note" size="mini"
              @change="changeNote(shopDataitem.id, shopDataitem.note)" />
            <div class="tagBtnList">
              <el-popover trigger="hover" placement="bottom" @hide="shopTagsMouseleave(shopDataitem)"
                popper-class="shopTagPopover" width="340px">
                <div>
                  <div class="fontSize14 color222" style="margin-bottom: 10px;font-weight: 500;">标签选择：</div>
                  <div>
                    <div v-for="(tagItem, tagIndex) in tagLists" :key="tagIndex" class="flexAndCenter tagItem">
                      <input type="checkbox" v-model="tagItem.checked" />
                      <div :title="tagItem.tag_name">{{ tagItem.tag_name }}</div>
                    </div>
                  </div>
                  <div class="flexAndCenter">
                    <el-input placeholder="タグ名をご記入ください" v-model="addTagTxt" />
                    <el-button @click="addTag" type="primary">追加</el-button>
                  </div>
                </div>
                <div slot="reference" class="btnLeft" @mouseenter="shopTagOpen(shopDataitem)">ラベル情報</div>
              </el-popover>
              <div class="btnRight" @click="delshop(shopDataindex, shopDataitem)">
                <img src="@/assets/user/commodity/Collected.png" alt="">
                <div>お気に入り外す</div>
              </div>
            </div>
          </div>
          <div class="optRight" v-if="shopDataitem.goods != null && shopDataitem.goods.length > 0">
            <div class="carouselBtn" @click="shopCarouselChange('left', shopDataindex)" style="margin-right: 20px">
              <img src="@/assets/user/commodity/jaintouzuo.png" alt="" />
            </div>

            <el-carousel ref="shopCarousel" trigger="click" width="100px" height="100px" :autoplay="false" arrow="never"
              indicator-position="none" v-if="shopDataitem.goods != null && shopDataitem.goods.length > 0">
              <el-carousel-item v-for="(goodsItem, goodsIndex) in shopDataitem.goods" :key="goodsIndex">
                <div class="optRightCon">
                  <div class="shopGoods" v-for="(iu, sndex) in goodsItem" :key="sndex">
                    <router-link
                      :to="iu.shopType == 'RAKUMART' ? '/details?id=' + iu.iid : `/details1688?iid=${iu.goodsId}&type=${iu.shopType}${iu.mi_id ? '&mi_id=' + iu.mi_id : ''}`"
                      target="_blank">
                      <el-image :src="iu.imgUrl" v-if="iu != null">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                        <div slot="placeholder">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                    </router-link>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="carouselBtn" @click="shopCarouselChange('right', shopDataindex)" style="margin-left: 20px">
              <img src="@/assets/user/commodity/jaintouyou.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="updateTagNameDialogVisible"
        :show-close="false" width="350px">
        <div class="flexAndCenter updateTagNameBox">
          <div class="label">新規修改：</div>
          <el-input style="width: 220px" v-model="tagInfo.tag_name" />
        </div>
        <span slot="footer" class="delete-dialog-footer">
          <el-button type="primary" @click="updateTagName">確定</el-button>
        </span>
      </el-dialog>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-size="form.pageSize" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import {
  favoriteShopList,
  favoriteTagList,
  favoriteTagNameEdit,
  favoriteShopDelete,
  favoriteTagAdd, favoriteShopNoteSave, favoriteShopToTags, favoriteTagDelete
} from "@/api/API/commodity";
import { changeArr, deepClone } from '@/utlis/utlis'
export default {
  data() {
    return {
      tagLists: [], //标签列表
      shopData: [], //收藏店铺列表
      addTagTxt: "", //添加标签的文本
      loading: true,
      total: 0,
      form: {
        keywords: '',
        tag_ids: '',
        page: 1,
        pageSize: 5
      },
      updateTagNameDialogVisible: false,
      tagInfo: {},
    };
  },
  created() {
    this.getTagData();
    // favoriteShopAdd({token: localStorage.getItem("token"),shop_type:'1688',shop_name:'海润窗纱制品',shop_id:'海润窗纱制品'}).then((res) => {
    // });
    this.getShopsList();
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    // 添加标签
    addTag(item) {
      if (!this.addTagTxt) return false;
      favoriteTagAdd({
        token: localStorage.getItem("token"),
        type: 2,
        tag_name: this.addTagTxt,
      }).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.addTagTxt = "";
        // 重新获取标签列表
        favoriteTagList({ type: "2", token: localStorage.getItem("token") }).then((res) => {
          res.data.forEach((item) => {
            item.id = item.id + ''
          })
          this.tagLists = res.data;
          // 调用处理标签列表事件
          this.tagDataProcessing();
          this.shopTagOpen(item);
          this.$forceUpdate();
        });
      });
    },
    // 全局鼠标点击事件
    bodyCloseMenus() {
      // 关闭所有商品的标签弹窗
      this.shopData.forEach((item) => {
        item.showTagWin = false;
      });
      this.$forceUpdate();
    },
    //删除icon
    deleteIcon(item) {
      this.$confirm(
        '削除の確認',
        '注意',
        {
          confirmButtonText: '確定', //确定
          cancelButtonText: 'キャンセル', //取消
          type: "warning",
          center: true,
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        favoriteTagDelete({
          tag_id: item.id,
          token: localStorage.getItem("token")
        }).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.getTagData();
          this.form.pageSize = 5;
          this.getShopsList();
        })
      })
    },
    //获取要编辑的tag信息
    getEditTagInfo(val) {
      this.tagInfo = deepClone(val);
      this.updateTagNameDialogVisible = true;
    },
    // 获取商品收藏夹标签列表并调用商品收藏夹列表获取函数
    getTagData() {
      favoriteTagList({ type: "2", token: localStorage.getItem("token") }).then((res) => {
        res.data.forEach((item) => {
          item.id = item.id + ''
        })
        this.tagLists = res.data;
        // 调用处理标签列表事件
        this.tagDataProcessing();
        // 调用获取商品收藏夹列表事件
      });
    },
    //获取要筛选的标签
    updateTagIndex(val) {
      if (this.form.tag_ids === '') {
        this.form.tag_ids = val.id
      } else if (this.form.tag_ids !== '' && this.form.tag_ids.indexOf(val.id) === -1) {
        this.form.tag_ids += ',' + val.id
      } else if (this.form.tag_ids !== '' && this.form.tag_ids.indexOf(val.id) !== -1) {
        let index = this.form.tag_ids.indexOf(val.id);
        let target = '';
        if (index === 0) {
          target = val.id;
        } else {
          target = ',' + val.id;
        }
        this.form.tag_ids = this.form.tag_ids.replace(target, "");
      }
      this.getShopsList();
    },
    // 处理收藏夹标签数据
    tagDataProcessing() {
      this.tagLists.forEach((item) => {
        item.checked = false;
        item.titleChecked = false;
      });
    },
    // 修改店铺备注
    changeNote(id, note) {
      favoriteShopNoteSave({
        id: id,
        note: note,
        token: localStorage.getItem("token")
      }).then(() => {
      });
    },
    // 分页事件
    handleSizeChange(val) {
      this.form.page_num = val;
      this.form.page = 1;
      this.getShopsList();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getShopsList();
    },
    // 滑动店铺商品列表
    shopCarouselChange(type, index) {
      if (type == "left") {
        this.$refs.shopCarousel[index].prev();
      } else if (type == "right") {
        this.$refs.shopCarousel[index].next();
      }
    },
    //更新标签的名称
    updateTagName() {
      if (this.tagInfo.tag_name !== '') {
        favoriteTagNameEdit({
          tag_id: this.tagInfo.id,
          tag_name: this.tagInfo.tag_name,
          token: localStorage.getItem("token"),
        }).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.updateTagNameDialogVisible = false;
          this.form.tag_ids = '';
          this.getTagData();
          this.form.pageSize = 5;
          this.tagInfo = {};
          this.form.page = 1;
          this.getShopsList();
        }).catch(() => {
        });
      }
    },
    // 获取店铺列表
    getShopsList() {
      this.loading = true;
      let datas = {
        tag_ids: this.form.tag_ids,
        page: this.form.page,
        pageSize: this.form.pageSize,
        keywords: this.form.keywords,
        token: localStorage.getItem("token")
      };
      favoriteShopList(datas).then((res) => {
        this.loading = false;
        this.shopData = res.data.data;
        this.total = res.data.total;
        this.ProcessingShopData();
      })
      this.ProcessingShopData();
    },
    //处理店铺数据
    ProcessingShopData() {
      this.shopData.forEach((item) => {
        if (item.goods != null) {
          let lack = 5 - (item.goods.length % 5); //取得店铺商品数离5个的倍数差多少个商品的数量
          //差多少个就从最前面取多少个填充到最后
          for (let i = 0; i < lack; i++) {
            item.goods.push(item.goods[i]);
          }
          //  把单个店铺的商品分成四个一组
          item.goods = changeArr(item.goods, 5);
          item.showTagWin = false;
        }
      });
      this.$forceUpdate();
    },
    // 打开分配店铺标签窗口
    shopTagOpen(item) {
      this.shopData.forEach((item) => {
        item.showTagWin = false;
      });
      let shopsTagIds = [];
      if (item.tag_ids != undefined && item.tag_ids != '') {
        shopsTagIds = item.tag_ids.split(",");
      }
      // 初始化商品标签列表数据
      this.tagLists.forEach((newItem) => {
        shopsTagIds.forEach((items) => {
          if (newItem.id == items) {
            newItem.checked = true;
          }
        })
      });
      item.showTagWin = true;
      this.$forceUpdate();
    },
    shopTagsMouseleave(item) {
      let tagIds = '';
      this.tagLists.forEach((tagItem) => {
        if (tagItem.checked === true) {
          tagIds += tagItem.id + ','
        }
      })
      tagIds = tagIds.substr(0, tagIds.length - 1);
      if (tagIds !== '') {
        favoriteShopToTags({
          id: item.id,
          tag_ids: tagIds,
          token: localStorage.getItem("token")
        }).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
        })
      }
    },
    // 删除店铺
    delshop(index, item) {
      this.$confirm(
        '店舗のお気に入りを取り消しますか？',
        '注意',
        {
          confirmButtonText: '確定', //确定
          cancelButtonText: 'キャンセル', //取消
          type: "warning",
          center: true,
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        favoriteShopDelete({
          shop_type: item.shop_type,
          shop_name: [item.shop_name],
          token: localStorage.getItem("token")
        }).then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.getShopsList();
          this.getTagData();
        })
      }).catch(() => {

      });
    },
  },
};
</script>
<style lang="scss" scoped>
#userOrder {
  @import "@/css/mixin";
  width: 100%;

  .EmployeesAccountTitle {
    height: 40px;
    padding: 0 20px;
    background: #EEEEEE;
    color: #222222;
    line-height: 40px;
    font-size: 20px;
  }

  section {
    background: #fff;
    padding: 20px 20px 0;

    .shops {
      min-height: 300px;

      .shopsOpt {
        height: 194px;
        border-radius: 5px;
        border: 1px solid #E9E9E9;
        padding: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .optLeft {
          width: 435px;
          height: 100%;
          position: relative;

          .goodsTitleBox {
            font-size: 20px;
            font-weight: 500;
            color: #222222;
            cursor: pointer;
            width: 240px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .shopBlockedBtn {
            margin-left: 20px;
            cursor: pointer;
            border-radius: 4px;
            height: 26px;
            display: flex;
            align-items: center;
            padding: 0 6px;
            background: #666666;
            color: #fff;
            font-size: 12px;

            img {
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }
          }

          /deep/ .el-input__inner {
            width: 240px;
            height: 32px;
            margin-bottom: 20px;
          }

          .tagBtnList {
            display: flex;
            align-items: center;

            .btnLeft {
              width: 90px;
              height: 32px;
              background: #F3C622;
              border-radius: 5px;
              text-align: center;
              line-height: 32px;
              cursor: pointer;
              color: #222222;
              font-size: 14px;
              margin-right: 10px;
            }

            .btnRight {
              display: flex;
              align-items: center;
              padding: 6px 10px;
              border-radius: 5px;
              border: 1px solid #E9E9E9;
              cursor: pointer;

              img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
              }

              div {
                color: #222222;
                font-size: 14px;
              }
            }

            /deep/ .input-with-select {}
          }

          .btns {
            img {
              width: 24px;
              height: 24px;
              cursor: pointer;

              &:first-child {
                margin-right: 20px;
              }
            }
          }

          .pop-up {
            position: absolute;
            top: 100% px;
            left: 0px;
            width: 246px;
            background: #ffffff;
            box-shadow: 0px 0px 10px 0px rgba(61, 61, 61, 0.1);
            border-radius: 10px;
            padding: 20px;
            z-index: 2;
            align-items: center;

            p {
              display: flex;
              margin-bottom: 12px;

              &:last-child {
                margin-bottom: 20px;
              }

              .che {
                width: 16px;
                height: 16px;
                background-color: #ffffff;
                border: solid 1px #dddddd;
                -webkit-border-radius: 3px;
                border-radius: 3px;
                font-size: 0.8rem;
                margin: 0;
                margin-right: 6px;
                padding: 0;
                position: relative;
                display: inline-block;
                vertical-align: top;
                cursor: default;
                -webkit-appearance: none;
                -webkit-user-select: none;
                user-select: none;
                -webkit-transition: background-color ease 0.1s;
                transition: background-color ease 0.1s;

                &:checked {
                  background: #1673ff;
                }

                &:checked::after {
                  content: "";
                  top: 1px;
                  left: 1px;
                  position: absolute;
                  background: transparent;
                  border: #fff solid 2px;
                  border-top: none;
                  border-right: none;
                  height: 6px;
                  width: 10px;
                  -moz-transform: rotate(-45deg);
                  -ms-transform: rotate(-45deg);
                  -webkit-transform: rotate(-45deg);
                  transform: rotate(-45deg);
                }
              }

              >span {
                display: block;
                height: 16px;
                max-width: 170px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;

                color: #000000;
                line-height: 16px;
                margin-right: auto;
              }
            }

            .addTagBtn {
              position: relative;
              height: 30px;

              input {
                width: 90%;
                height: 100%;
                background: #ffffff;
                border-radius: 15px;
                border: 1px solid rgba(30, 41, 151, 0.3);
                padding: 0 12px;
                font-size: 14px;
              }

              /deep/ .el-button {
                position: absolute;
                right: 0;
                top: 0;
                height: 30px;
                width: 64px;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 15px;
              }
            }
          }
        }

        .optRight {
          width: 660px;
          display: flex;
          align-items: center;

          .carouselBtn {
            width: 20px;
            height: 20px;
            cursor: pointer;

            img {
              width: 20px;
            }
          }

          /deep/ .el-carousel__arrow--right,
          /deep/ .el-carousel__arrow--left {
            height: 0;
            overflow: hidden;
          }

          .el-carousel {
            width: 580px;
          }

          /deep/ .el-carousel__arrow {
            background: rgba(255, 255, 255, 0.5);

            i {
              color: $homePageSubjectColor;
            }
          }

          /deep/ .el-carousel__button {
            width: 12px;
            height: 12px;
            background: #ffffff;
            border-radius: 50%;
          }

          /deep/ .el-carousel__indicator.el-carousel__indicator--horizontal.is-active .el-carousel__button {
            background-color: transparent;
          }

          .optRightCon {
            width: 580px;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .shopGoods {
              width: 100px;
              height: 100px;
              cursor: pointer;

              /deep/ .el-image {
                $imgSize: 100px;
                width: $imgSize;
                height: $imgSize;
                transition: 0.3s;
                text-align: center;

                i {
                  font-size: $imgSize/4;
                  line-height: $imgSize;
                }
              }
            }
          }
        }
      }
    }

    .allpag {
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 25px 0;
      padding-bottom: 30px;
    }

    .shopHeader {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #E9E9E9;
      padding-bottom: 20px;
      margin-bottom: 20px;

      .shopHeaderLeft {
        color: #333333;
        font-size: 14px;
        margin-right: 26px;
        display: flex;

        .tagLists {
          margin-left: 26px;
          display: flex;
          flex-wrap: wrap;
          width: 500px;

          .tagContainer {
            padding: 6px 9px;
            color: #333333;
            font-size: 12px;
            background: #F0F0F0;
            border-radius: 6px;
            margin-right: 12px;
            cursor: pointer;
            position: relative;
            margin-bottom: 10px;
          }

          .active {
            background: #fff;
            color: #B4272B;
            border: 1px solid #B4272B;
          }

          .tagContainer {
            position: relative;
            padding: 7px 9px;
            color: #333;
            font-size: 12px;
            border-radius: 6px;
            background: #F0F0F0;
            margin-right: 22px;
            margin-bottom: 12px;
            cursor: pointer;
          }

          .deleteTagContainer {
            width: 16px;
            height: 16px;
            background: #B4272B;
            border-radius: 50%;
            color: #fff;
            text-align: center;
            font-size: 12px;
            line-height: 15px;
            cursor: pointer;
            position: absolute;
            left: -5px;
            top: -5px;
          }

          img {
            position: absolute;
            right: -5px;
            top: -5px;
            width: 14px;
            height: 16px;
          }
        }
      }

      .shopHeaderRight {
        display: flex;
        align-items: center;

        .keywords {
          /deep/ .el-input__inner {
            width: 220px;
            height: 32px;
            border-radius: 5px;
            border: 1px solid #E9E9E9;
          }
        }

        .btnList {
          margin-left: 10px;

          div {
            width: 80px;
            height: 32px;
            border-radius: 5px;
            background: #F3C622;
            color: #222222;
            font-size: 14px;
            font-weight: 500;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
          }

          div:last-child {
            margin-left: 5px;
            border: 1px solid #E9E9E9;
            background: #fff;
          }
        }
      }
    }
  }
}
</style>
